export default __webpack_public_path__ + "static/media/rock6.5dc67330.jpg";